import { render, staticRenderFns } from "./user_center_my.vue?vue&type=template&id=6e6dad04&scoped=true"
import script from "./user_center_my.vue?vue&type=script&lang=js"
export * from "./user_center_my.vue?vue&type=script&lang=js"
import style0 from "./user_center_my.css?vue&type=style&index=0&id=6e6dad04&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6dad04",
  null
  
)

export default component.exports